"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const SSHNodeValidation_1 = require("../validations/SSHNodeValidation");
class SSHNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.SSH };
    if (props.type !== types_1.NODE_TYPES.SSH)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData)
      nodeData = {
        config: "",
        command: "",
        host: "",
        port: "",
        username: "",
        proxy: "",
        isProxyNode: false
      };
    return {
      ...nodeData,
      config: nodeData.config.substr(1)
    };
  }
  serialize(uiData) {
    return {
      ...uiData,
      config: "@" + uiData.config,
      proxy: uiData.isProxyNode ? ":credentials" : undefined
    };
  }
  //if proxy type is selected
  getTarget() {
    const nodeData = this.getNodeData();
    if (nodeData && nodeData.isProxyNode) {
      return {
        activity: "ssh-proxy"
      };
    }
    return super.getTarget();
  }
  validate() {
    return new SSHNodeValidation_1.SSHNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.SSHNode = SSHNode;
//# sourceMappingURL=SSHNode.js.map
